import { CHAIN_IDS } from '@/utils/wagmi'
import { useAccount } from 'wagmi'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { Typography } from '@/components/ui/typography'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Connector } from '@/components/connector'
import { toast } from 'sonner'
import { isAddress } from 'viem'
import { cn } from '@/lib/utils'
import { AnimatedGridPattern } from '@/components/ui/animated-grid-pattern'

export default function PortfolioIndexPage() {
  const [label, setLabel] = useState('')
  const router = useRouter()
  const { address } = useAccount()

  useEffect(() => {
    if (address) {
      router.push(`/portfolio/${address}`)
    }
  }, [address])

  const onTrack = () => {
    try {
      if (isAddress(label)) {
        router.push(`/portfolio/${label}`)
      } else {
        toast.error('invalid address')
      }
    } catch (e) {
      console.error(e)
      toast.error((e as Error).message)
    }
  }

  return (
    <main className="container mx-auto px-6">
      <AnimatedGridPattern
        maxOpacity={0.1}
        duration={3}
        repeatDelay={6}
        className={cn(
          '[mask-image:radial-gradient(1000px_circle_at_center,white,transparent)]',
          'inset-x-0 inset-y-[-30%] h-[100%] skew-y-8',
        )}
      />
      <div className="flex flex-col items-center md:pt-28 pt-10">
        <Typography className={'text-5xl mb-2 font-semibold font-averia-libre'}>Moonforge</Typography>
        <Typography className={'text-5xl mb-6 font-semibold font-averia-libre'}>Portfolio</Typography>
        <Typography className={'text-xl text-foreground/80 mb-12 font-averia-libre'}>
          Track all your assets, in one place.
        </Typography>
        <div className="w-[500px] max-w-full">
          <div className="flex items-center gap-4 mb-4">
            <Input
              placeholder={'Enter address or hl name'}
              size={'lg'}
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            />
            <Button size={'lg'} onClick={onTrack}>
              Track
            </Button>
          </div>
          <div className="flex justify-center mt-8">
            <Connector />
          </div>
        </div>
      </div>
    </main>
  )
}

PortfolioIndexPage.chains = CHAIN_IDS
